import Vue from 'vue'
import Vuex from 'vuex'

import {auth} from '@/modules/core/store/auth-module';
import {snackbar} from '@/modules/core/store/snackbar';
import {translation} from '@/modules/core/store/translation';
import {request} from '@/modules/core/store/request';
import {manager} from '@/modules/core/store/module-manager';
import {dtableFilter} from '@/modules/core/store/dtable-filter';
import {tag}  from '@/modules/core/store/tag';
import {overlay} from "@/modules/core/store/overlay";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    snackbar,
    translation,
    request,
    manager,
    dtableFilter,
    tag,
    overlay
  }
})
